/* eslint-disable */
require('./attachment-upload')
require('./bmp')
require('./companies')
require('./doc')
require('./download')
require('./guitar')
require('./instruments')
require('./jpg')
require('./pdf')
require('./png')
require('./qrcode')
require('./sent')
require('./svg')
require('./telephone')
require('./trash')
require('./unknown')
require('./update')
require('./upload')
require('./zip')
